

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { Getter } from "vuex-class"
import { Team } from "@/types"
import vSelect from "vue-select"
import { TenantFeatures } from "@/types/tenantFeatures"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class TeamPermissionsSelector extends Vue {
	@Prop()
	value!: string[] | null

	@Prop({ default: () => [] })
	teams!: Team[]

	@Prop()
	placeholder!: string

	@Prop({ default: false })
	readonly!: boolean

	/**
	 * If value is not null, require it to have at least one team
	 */
	@Prop({ default: false })
	requireTeamsIfSet!: boolean

	@Prop({ type: Array, default: () => [] })
	public requiredValues!: string[]

	@Prop({ type: String, default: "" })
	public requiredValueTooltip!: string;

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	get enabled (): boolean {
		return !!this.value
	}
	set enabled (value: boolean) {
		this.$emit("input", value ? (this.value ? this.value : []) : null)
	}

	get label () {
		if (!this.enabled) {
			return "Not enabled"
		}

		if (this.value && this.value.length > 0) {
			return this.value.map(teamId => this.teams.find(t => t.id === teamId))
				.filter(t => !!t)
				.map(t => t!.title)
				.join(", ")
		} else {
			return "Anyone"
		}
	}

	updateValue (newValue: string[]) {
		this.$emit("input", newValue)
	}

	private get closeOnSelect ():boolean {
		return !(this.getIsFeatureEnabled(TenantFeatures.MultiSelectKeepOpen))
	}
}

